/* eslint-disable hubspot-dev/no-private-classes */
'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["icon", "value"],
  _excluded2 = ["dropdownClassName", "open", "options", "value"];
import PropTypes from 'prop-types';
import { Component } from 'react';
import classNames from 'classnames';
import memoize from 'react-utils/memoize';
import SimpleStyledCaret from '../internal/SimpleStyledCaret';
import SimpleStyledClickable from '../internal/SimpleStyledClickable';
import UIIconButton from 'UIComponents/button/UIIconButton';
import SyntheticEvent from 'UIComponents/core/SyntheticEvent';
import UIAbstractDropdown from 'UIComponents/dropdown/abstract/UIAbstractDropdown';
import UITextToolbarIcon from '../../editor/UITextToolbarIcon';
import UIList from 'UIComponents/list/UIList';
import { SingleValueType } from 'UIComponents/types/OptionTypes';
import { moveFocusToNext } from 'UIComponents/utils/Dom';
import { uniqueId } from 'UIComponents/utils/underscore';
import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
const getDropdownClassName = dropdownClassName => classNames('private-dropdown--list', dropdownClassName);
class UIAbstractIconDropdown extends Component {
  constructor(props) {
    super(props);
    this.handleKeyDown = evt => {
      const {
        key
      } = evt;
      const {
        open
      } = this.props;
      if (!open) return;
      if (key === 'ArrowDown' || key === 'ArrowUp') {
        const menu = document.getElementById(this._id);
        if (!menu) return;
        if (moveFocusToNext('li', menu, key === 'ArrowUp')) {
          evt.preventDefault();
        }
        evt.stopPropagation();
      }
    };
    this._id = `icon-dropdown-${uniqueId()}`;
    this.getHandleChange = memoize(this.getHandleChange.bind(this));
  }
  getHandleChange(value) {
    const event = SyntheticEvent(value);
    return () => {
      const {
        onOpenChange,
        onChange,
        open
      } = this.props;
      onChange(event);
      onOpenChange(SyntheticEvent(!open));
    };
  }
  renderOptions(options) {
    return options.map(_ref => {
      let {
          icon,
          value
        } = _ref,
        rest = _objectWithoutPropertiesLoose(_ref, _excluded);
      return /*#__PURE__*/_createElement(UIIconButton, Object.assign({}, rest, {
        key: icon,
        onClick: this.getHandleChange(value),
        placement: "right",
        use: "transparent"
      }), /*#__PURE__*/_jsx(UITextToolbarIcon, {
        name: icon
      }));
    });
  }
  render() {
    const _this$props = this.props,
      {
        dropdownClassName,
        open,
        options
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded2);
    const computedDropdownClassName = getDropdownClassName(dropdownClassName);
    return /*#__PURE__*/_jsx(UIAbstractDropdown, Object.assign({}, rest, {
      Button: SimpleStyledClickable,
      caretRenderer: /*#__PURE__*/_jsx(SimpleStyledCaret, {}),
      dropdownClassName: computedDropdownClassName,
      menuWidth: 50,
      open: open,
      onKeyDown: this.handleKeyDown,
      children: /*#__PURE__*/_jsx(UIList, {
        id: this._id,
        children: this.renderOptions(options)
      })
    }));
  }
}
UIAbstractIconDropdown.propTypes = Object.assign({}, UIAbstractDropdown.propTypes, {
  defaultValue: SingleValueType,
  dropdownClassName: PropTypes.string,
  onChange: PropTypes.func,
  onOpenChange: PropTypes.func,
  open: PropTypes.bool.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    icon: UITextToolbarIcon.propTypes.name,
    value: SingleValueType
  }).isRequired).isRequired,
  value: SingleValueType
});
UIAbstractIconDropdown.defaultProps = Object.assign({}, UIAbstractDropdown.defaultProps, {
  open: false
});
UIAbstractIconDropdown.displayName = 'UIAbstractIconDropdown';
export default UIAbstractIconDropdown;